import { __decorate } from "tslib";
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import SimpleTable from "@/components/SimpleTable.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
let Sessions = class Sessions extends Vue {
    _fetchSessions;
    clearSessions;
    removeSession;
    findSessionsStore;
    sessionsLoadings;
    totalRows = 0;
    perPage = 10;
    currentPage = 1;
    pageWatcher() {
        this.fetchSessions();
    }
    get columns() {
        const columns = [
            {
                label: 'sessions.login',
                name: 'createdAt',
                field: item => {
                    const createdAt = this.$moment(item.createdAt).calendar();
                    if (item.token === localStorage.getItem('feathers-jwt'))
                        return createdAt + `<span class="badge badge-success badge-pill ml-2">${this.$t('Your session')}</span>`;
                    return createdAt;
                }
            },
            {
                label: 'sessions.last-action',
                name: 'lastAction',
                field: item => {
                    return this.$moment(item.lastAction).calendar();
                }
            },
            {
                label: 'sessions.user-agent',
                name: 'user-agent',
                style: {
                    value: { 'white-space': 'initial' },
                },
                field: item => {
                    return item.userAgent;
                }
            },
            {
                label: 'sessions.ip',
                name: 'ip',
                field: item => {
                    const ip = item.ipAddress;
                    return ip.substr(ip.lastIndexOf(':') + 1);
                },
                subtitle: item => {
                    const ip = item.ipAddress;
                    return ip.substr(0, ip.lastIndexOf(':'));
                }
            },
            {
                label: 'Team member',
                name: 'user',
                field: item => {
                    if (item.user)
                        return `${item.user.firstName} ${item.user.lastName}`;
                    return '-';
                }
            }
        ];
        return columns;
    }
    get query() {
        const query = {
            $sort: { lastAction: -1 },
            $limit: this.perPage,
            $skip: (this.currentPage - 1) * this.perPage
        };
        return query;
    }
    get sessions() {
        const query = Object.assign({}, this.query, { $skip: 0 });
        return this.findSessionsStore({ query }).data.map(el => ({ ...el, can_delete: true, blocked: true }));
    }
    fetchSessions() {
        this.clearSessions();
        this._fetchSessions({ query: this.query }).then(data => {
            this.totalRows = data.total;
        });
    }
    mounted() {
        this.fetchSessions();
    }
    deleteSession(item) {
        return this.removeSession(item._id);
    }
};
__decorate([
    Watch('currentPage')
], Sessions.prototype, "pageWatcher", null);
Sessions = __decorate([
    Component({
        components: { SimpleTable },
        computed: {
            ...mapState('sessions', { sessionsLoading: 'isFindPending' }),
            ...mapGetters('sessions', { findSessionsStore: 'find' }),
        },
        methods: {
            ...mapActions('sessions', { _fetchSessions: 'find', removeSession: 'remove' }),
            ...mapMutations('sessions', { clearSessions: 'clearAll' })
        }
    })
], Sessions);
export default Sessions;
